<div class="max-w-full mx-auto">
  <h2 class="text-3xl font-semibold text-center text-gray-800 mb-3 uppercase">LISTADO DE TARIFAS</h2>
  <div class="overflow-auto rounded-lg shadow-lg">
    <table class="w-full leading-normal">
      <thead class="bg-orange-500 text-white">
        <tr>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            CIF</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Delegación</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Código de cliente</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            ID de Concepto</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Descripción</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            ID de Proveedor</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Proveedor</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Cantidad</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Descuento</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Método de pago</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">
            Día de pago</th>
        </tr>
      </thead>
      <tbody class="bg-white">
        <tr *ngFor="let fee of fees" class="hover:bg-orange-100 transition duration-150 ease-in-out">
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ fee.cif }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ fee.delegation }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ fee.clientCode }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ fee.conceptId }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ fee.description }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ fee.familyId }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ fee.family }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ fee.amount }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ fee.discount }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ fee.payMethod }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ fee.payDay }}</td>

        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="bg-white shadow-md rounded-lg mt-5 p-7" *ngIf="fees.length === 0 && !isLoading">
  <h1 class="text-2xl font-bold text-center text-gray-600">
    No se encontraron tarifas.
  </h1>
</div>

<ng-container *ngIf="fees.length > 0">
  <div class="relative mb-5">
    <mat-paginator [length]="totalFees" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]"
      [showFirstLastButtons]="true" aria-label="Select page" (page)="handlePageEvent($event)">
    </mat-paginator>
  </div>
</ng-container>


<div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white opacity-75">
  <svg class="animate-spin h-5 w-5 text-orange-500 ml-2" xmlns="http://www.w3.org/2000/svg" fill="none"
    viewBox="0 0 24 24">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
    </path>
  </svg>
</div>